import React from 'react';

// Styles & Assets
import styles from './ScoreRulesView.module.css';

// Language
import { useTranslation } from 'react-i18next';

// Interfaces
import { IScoreRule } from '../../../interfaces/Score';
interface Props {
    scoreRules: IScoreRule[]
}

const ScoreRulesView: React.FC<Props> = ({ scoreRules }) => {

    const { t } = useTranslation();

    return (
        <>{scoreRules.length > 0 &&
            <div className={styles.container}>
                <h2 className='dialogSubTitle'>{t('rules_score')}</h2>
                <div className={styles.rulesContainer}>
                    {scoreRules.map(rule =>
                        <div key={rule.id} className={styles.ruleContainer}>
                            <div className={styles.circle} style={{ backgroundColor: rule.color_alert ?? undefined }}></div>
                            <p>{t('global_value_is')}</p>
                            <p className={styles.bigText}>{rule.comparison}</p>
                            <p>{t('than')}</p>
                            <p className={styles.bigText}>{rule.value}</p>
                        </div>
                    )}
                </div>
            </div>
        }</>
    );
};

export default ScoreRulesView;